module.exports = __webpack_public_path__ + "media/images/arrow-down-fcb7d75ebe1539258a7791a17bc0ee49.svg";